import {
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { errorToast, successToast } from "../../helpers";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { CommonBody } from "../../types/General";
import { useAddNotificationMutation } from "../../services/notification";
import useTranslation from "../../hooks/Translation";

const AddNotification = () => {
  const t = useTranslation();
  const navigate = useNavigate();
  const [dropdownType, setDropdownType] = useState("");
  const [addNotification] = useAddNotificationMutation();
  const [notificationDropdownType, setNotificationDropdownType] = useState<
    any[]
  >([]);
  const [notificationFor, setNotificationFor] = useState<number>();
  const [notificationType, setNotificationType] = useState<number>();

  const handleDropdownTypeChange = async (event: any) => {
    const selectedType = event.target.value;
    setDropdownType(selectedType);
    switch (selectedType) {
      case "User":
        setNotificationFor(1);
        break;
      case "Vendor":
        setNotificationFor(2);
        break;
      case "Select All":
        setNotificationFor(3);
        break;
      default:
        return;
    }
  };

  const handleNotificationDropdownTypeChange = async (event: any) => {
    const selectedType = event.target.value;
    setNotificationDropdownType(selectedType);
    switch (selectedType) {
      case "Brodcast":
        setNotificationType(1);
        break;
      case "Email":
        setNotificationType(2);
        break;
      default:
        return;
    }
  };

  const formik = useFormik({
    initialValues: {
      title: "",
      message: "",
    },
    validationSchema: Yup.object({
      title: Yup.string()
        .required(t.error.required)
        .max(80, t.error.maxValidation)
        .min(2, t.error.minValidation),
      message: Yup.string()
        .required(t.error.required)
        .max(250, t.error.max250)
        .min(2, t.error.minValidation),
    }),
    onSubmit: async (values) => {
      if (dropdownType.length <= 0) {
        errorToast(t.error.atLeast1Receiver);
        return;
      }
      if (notificationDropdownType.length <= 0) {
        errorToast(t.error.oneNotificationType);
        return;
      }

      let body: any = {
        notification_title: formik.values.title,
        notification_message: formik.values.message,
        notification_type: notificationType,
        notification_for: notificationFor,
      };

      console.log(body);
      try {
        const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
        const response = await addNotification(encryptedBody).unwrap();
        if (response.status === 200) {
          successToast(response?.message || "");
          navigate("/manage-notifications");
        } else {
          errorToast(response.message);
        }
      } catch (e: any) {
        console.error("API call failed", e);
        errorToast(e?.data?.message);
      }
    },
  });

  return (
    <>
      <div>
        <div className="main_loyout">
          <div className="dashboard">
            <h1 className="mn_hdng">{t.main.addNotification}</h1>
            <Button
              className="btn btn_primary"
              onClick={() => {
                navigate("/manage-notifications");
              }}
            >
              {t.main.back}
            </Button>
          </div>
          <Card className="cards">
            <form onSubmit={formik.handleSubmit}>
              <CardContent sx={{ p: 1 }}>
                <Grid container spacing={2}>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Typography className="custom_label">
                      {t.main.notificationTitle}
                    </Typography>
                    <TextField
                      hiddenLabel
                      type="text"
                      name="title"
                      variant="outlined"
                      fullWidth
                      placeholder={t.main.notificationTitle}
                      value={formik.values.title}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.title && Boolean(formik.errors.title)
                      }
                      helperText={
                        formik.touched.title && formik.errors.title
                          ? formik.errors.title.toString()
                          : ""
                      }
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Typography className="custom_label">
                      {t.main.notificationMessage}
                    </Typography>
                    <TextField
                      hiddenLabel
                      type="text"
                      name="message"
                      variant="outlined"
                      fullWidth
                      placeholder={t.main.notificationMessage}
                      value={formik.values.message}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.message && Boolean(formik.errors.message)
                      }
                      helperText={
                        formik.touched.message && formik.errors.message
                          ? formik.errors.message.toString()
                          : ""
                      }
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Typography className="custom_label">
                      {t.main.receiverType}
                    </Typography>
                    <FormControl sx={{ width: "100%" }}>
                      <Select
                        value={dropdownType}
                        onChange={handleDropdownTypeChange}
                        displayEmpty
                      >
                        <MenuItem value="" disabled>
                          {t.main.receiverType}
                        </MenuItem>
                        <MenuItem value="User">{t.main.user}</MenuItem>
                        <MenuItem value="Vendor">{t.main.vendor}</MenuItem>
                        <MenuItem value="Select All">
                          {t.main.selectAll}
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Typography className="custom_label">
                      {t.main.notificationType}
                    </Typography>
                    <FormControl sx={{ width: "100%" }}>
                      <Select
                        value={notificationDropdownType}
                        onChange={handleNotificationDropdownTypeChange}
                        displayEmpty
                      >
                        <MenuItem value="" disabled>
                          {t.main.notificationType}
                        </MenuItem>
                        <MenuItem value="Brodcast">{t.main.broadcast}</MenuItem>
                        <MenuItem value="Email">{t.main.email}</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
                <div className="form_btn">
                  <Button
                    size="large"
                    type="submit"
                    className="btn btn_primary"
                  >
                    {t.main.save}
                  </Button>
                </div>
              </CardContent>
            </form>
          </Card>
        </div>
      </div>
    </>
  );
};

export default AddNotification;
